import type { ReactNode } from "react";

/**
 * A map-first page (the approved Waste.dc.html pattern): the map fills the content area; the list floats in a white
 * rail on the left (its legend at the rail's foot), the selected record's inspector on the right, and the zoom buttons
 * bottom right (FireMap). Under 900 px the panels stack below the map.
 */
export function MapPage({
  map,
  title,
  head,
  children,
  inspector,
  inspectorLabel,
  legend,
}: {
  /** A FireMap with `fill`. */
  map: ReactNode;
  /** The screen's heading (h2). */
  title: string;
  /** Under the heading: the live line, filters, the main action. */
  head?: ReactNode;
  /** The rail's list. */
  children: ReactNode;
  /** The selected record (null: none). */
  inspector?: ReactNode;
  inspectorLabel?: string;
  legend?: ReactNode;
}) {
  return (
    <div className="fer-screen fer-screen--map">
      <div className="fer-mapfill">{map}</div>
      <div className="fer-rail">
        <div className="fer-rail__head">
          <h2>{title}</h2>
          {head}
        </div>
        <div className="fer-rail__body">{children}</div>
        {legend && <div className="fer-rail__foot">{legend}</div>}
      </div>
      {inspector && (
        <div className="fer-inspector" role="group" aria-label={inspectorLabel}>
          {inspector}
        </div>
      )}
    </div>
  );
}
